var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplicationBase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2532_20060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 3.25H13.8333C14.2311 3.25 14.6126 3.40804 14.8939 3.68934C15.1752 3.97064 15.3333 4.35218 15.3333 4.75V15.25C15.3333 15.6478 15.1752 16.0294 14.8939 16.3107C14.6126 16.592 14.2311 16.75 13.8333 16.75H4.83325C4.43543 16.75 4.0539 16.592 3.77259 16.3107C3.49129 16.0294 3.33325 15.6478 3.33325 15.25V4.75C3.33325 4.35218 3.49129 3.97064 3.77259 3.68934C4.0539 3.40804 4.43543 3.25 4.83325 3.25H6.33325",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5833 1.75H7.08325C6.66904 1.75 6.33325 2.08579 6.33325 2.5V4C6.33325 4.41421 6.66904 4.75 7.08325 4.75H11.5833C11.9975 4.75 12.3333 4.41421 12.3333 4V2.5C12.3333 2.08579 11.9975 1.75 11.5833 1.75Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2532_20060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.333252 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationBase);
export default __webpack_public_path__ + "static/media/application-base.0c81fbf11ec72cdc74a3c706a7adfe52.svg";
export { ForwardRef as ReactComponent };